import type React from "react";
import { Box, Typography } from "@mui/material";
import ServiceAutocomplete from "../../components/ServiceAutoComplete";
import type { PackageBuilderState } from "../types";

interface Props {
  state: PackageBuilderState;
  update: (patch: Partial<PackageBuilderState>) => void;
}

const ServicesTab: React.FC<Props> = ({ state, update }) => (
  <Box sx={{ maxWidth: 760 }}>
    <Typography
      sx={{
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: 0.5,
        textTransform: "uppercase",
        mb: 0.75,
        color: "text.secondary",
      }}
    >
      Base Services
    </Typography>
    <Typography sx={{ fontSize: 13, color: "text.secondary", mb: 1.5 }}>
      Services bundled into this package. These show on proposals and the booking
      breakdown.
    </Typography>
    <ServiceAutocomplete
      value={state.base_services}
      onChange={(services) => update({ base_services: services })}
    />
  </Box>
);

export default ServicesTab;
